// Si padding=true on affiche les centimes mêmes quand il y a 0
// 2.99 => 2,99 €
// 8.00 => 8,00 €
export function formatPriceToEuros(price: number, padding: boolean = true): string {
    const intPart = Math.trunc(price);
    const floatPart = (price - intPart).toFixed(2).slice(-2);
    if (padding || floatPart !== "00") {
        return `${intPart},${floatPart}&#8239;€`;
    } else {
        return `${intPart}&#8239;€`;
    }
}


// Formate le prix pour OB1 (supprime l'espace avant le "€", n'affiche pas les décimals si "00"
// 299 => 2,99 €
// 800 => 8 € (padding à false)
// 800 => 8,00 € (padding à true)
export function formatPriceInCentsToEuros(price: number, padding: boolean = true): string {
    return formatPriceToEuros(price / 100, padding);
}


// Formate un nombre en ajoutant une virgule pour séparer les milliers
export function formatNumber(amount: number): string {
    const intPart = Math.trunc(amount);
    const floatPart = (amount - intPart).toFixed(1).slice(-1);
    return `${intPart},${floatPart}`;
}
